function typeOf (obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

export default {
  methods: {
    equals (a, b) {
      // first compare array, because typeof [] === 'object'
      if (Array.isArray(a) && Array.isArray(b)) {
        return this.equalArray(a, b)
      } else if (typeof a === 'object' && typeof b === 'object') {
        return this.equalObj(a, b)
      } else if (a === b) {
        return true
      } else {
        return false
      }
    },
    equalObj (newObj, oldObj) {
      let equal = true
      let props = Object.keys(newObj || {})
      for (let i = 0, len = props.length; i < len; i++) {
        let prop = props[i]
        let newVal = newObj[prop]
        let oldVal = oldObj[prop]
        if (!this.equals(newVal, oldVal)) {
          equal = false
          break
        }
      }
      return equal
    },
    equalArray (newArray, oldArray) {
      let newA = newArray || []
      let oldA = oldArray || []
      if (newA.length !== oldA.length) return false

      let equal = true
      for (let i = 0, len = newA.length; i < len; i++) {
        let newVal = newA[i]
        let oldVal = oldA[i]
        if (!this.equals(newVal, oldVal)) {
          equal = false
          break
        }
      }
      return equal
    },
    deepCopy (data) {
      const t = typeOf(data)
      let o

      if (t === 'array') {
        o = []
      } else if (t === 'object') {
        o = {}
      } else {
        return data
      }

      if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
          o.push(this.deepCopy(data[i]))
        }
      } else if (t === 'object') {
        for (let i in data) {
          o[i] = this.deepCopy(data[i])
        }
      }
      return o
    }
  }
}
